// ------------------------------------
// props 輸入需求 : 
// props.hide : function( void )                    ( 開關按鈕 )
// props.data : object : { data: array }            (  )
// ------------------------------------

import React from 'react'


const ResidentArrPad =(props)=>{
    let name = props.res.name
    let id = props.res.id
    return(
        <div className={`res_layout ${props.type}`} 
            onMouseEnter={()=>props.setSelectionEff(true)} 
            onMouseLeave={()=>props.setSelectionEff(false)}
            onMouseDown={()=>props.setSelectionEff(true)}
            onClick={()=>{
                props.remove(props.index)
                props.setSelectionEff(false)
                props.setSelectedResidnet([name, id])
            }}>
            {props.selectionEff? <>
                <div className='corner_frame _bl'></div>
                <div className='corner_frame _br'></div>
                <div className='corner_frame _tl'></div>
                <div className='corner_frame _tr'></div>
            </>:null}
            {name}
        </div>
    );	

}
export default ResidentArrPad;